import React from "react";
import { useTranslation } from "react-i18next";
import "../../pages/pets/PetProfilePage.css";

const PetProfileView = ({ petData, handleEditSection, isOwner = false }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const basicFields = [
    { key: "name", label: t("petProfileView.fields.name"), value: petData.name || t("petProfileView.values.notSpecified") },
    { key: "color", label: t("petProfileView.fields.color"), value: petData.color || t("petProfileView.values.notSpecified") },
    { key: "species", label: t("petProfileView.fields.species"), value: typeof petData.species === 'object' && petData.species?.name ? petData.species.name : (petData.species || t("petProfileView.values.unknown")) },
    { key: "gender", label: t("petProfileView.fields.gender"), value: petData.gender ? (petData.gender.toLowerCase() === "male" ? t("petProfileView.values.male") : petData.gender.toLowerCase() === "female" ? t("petProfileView.values.female") : petData.gender) : t("petProfileView.values.notSpecified") },
    { key: "breed", label: t("petProfileView.fields.breed"), value: typeof petData.breed === 'object' && petData.breed?.name ? petData.breed.name : (petData.breed || t("petProfileView.values.notSpecified")) },
    { key: "age", label: t("petProfileView.fields.age"), value: petData.age || t("petProfileView.values.notSpecified") },
    { key: "weight", label: t("petProfileView.fields.weight"), value: petData.weight || t("petProfileView.values.notSpecified") },
  ];

  const otherFields = [
    { key: "microchipId", label: t("petProfileView.fields.microchipId"), value: petData.microchipId || t("petProfileView.values.notSpecified") },
    { key: "smartCollarId", label: t("petProfileView.fields.smartCollarId"), value: petData.smartCollarId || t("petProfileView.values.notSpecified") },
    { key: "spayedNeutered", label: t("petProfileView.fields.spayedNeutered"), value: petData.spayedNeutered || t("petProfileView.values.notSpecified") },
    { key: "provider", label: t("petProfileView.fields.provider"), value: petData.provider || t("petProfileView.values.notSpecified") },
    { key: "providerNumber", label: t("petProfileView.fields.providerNumber"), value: petData.providerNumber || t("petProfileView.values.notSpecified") },
  ];

  const renderSection = (title, fields, sectionKey) => (
    <div className="ppv-section">
      <div className="ppv-section-header">
        <h3 className="ppv-section-title">{title}</h3>
        {isOwner && (
          <button
            onClick={() => handleEditSection(sectionKey)}
            className="ppv-edit-btn"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            {t("petProfileView.edit")}
          </button>
        )}
      </div>
      <div className="ppv-fields-grid" dir={isRTL ? "rtl" : "ltr"}>
        {fields.map((field) => (
          <div key={field.key} className="ppv-field">
            <span className="ppv-field-label">{field.label}</span>
            <span className="ppv-field-value">{field.value}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="ppv-container" dir={isRTL ? "rtl" : "ltr"}>
      {renderSection(t("petProfileView.basicInformation"), basicFields, "basic")}
      {renderSection(t("petProfileView.otherInformation"), otherFields, "other")}
    </div>
  );
};

export default PetProfileView;
